import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';

import { Observable } from 'rxjs';
import { Option } from '@app/forms/formly/formly-utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'dropdown-field',
  templateUrl: './dropdown-field.component.html',
  styleUrls: ['./dropdown-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFieldComponent
  extends FieldType<FieldTypeConfig<FormlyFieldConfig['props'] & { options: Observable<Option[]> }>>
  implements OnInit
{
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private dr: DestroyRef,
  ) {
    super();
  }

  ngOnInit() {
    this.formControl.valueChanges
      .pipe(takeUntilDestroyed(this.dr))
      .subscribe(() => this.changeDetectorRef.detectChanges());
  }
}
